/**
 * Blog queries
 */

import gql from 'graphql-tag'
export const getBlogQuery = gql`
  query getBlogByRoute($route: String!, $preview: Boolean) {
    blog: getBlogByRoute(route: $route, preview: $preview) {
      id
      title
      description
      desktopImage: desktop_image
      mobileImage: mobile_image
      icon
      user_name
      created_at
      updated_at
      published_at
      content
      category
      likes
      dislikes
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Blog/data.ts